import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import VideoPopover from "../../subtitle/VideoPopover";
import AiVideoPopover from "./AiVideoPopover";

const toolsList = [
  {
    name: "Video",
    icon: "/tool/dashboard/static/images/icons/subtitle/video.svg",
    selectedIcon: "/tool/dashboard/static/images/icons/subtitle/selectedVideo.svg",
  },
];

const AiDubbingTools = ({ isModalVisible, setIsModalVisible }) => {
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState(0);
  const onTabClick = (value) => {
    setCurrentTab(value);
    setIsModalVisible(true);
  };
  console.log("isModalVisible", isModalVisible);
  return (
    <>
      {isModalVisible && (
        <div
          className="fixed inset-0 flex items-center justify-center z-[98] bg-transparent"
          onClick={() => {
            setIsModalVisible(false);
            setCurrentTab(null);
          }}
        >
          <div
            className="bg-[#F4F3F6] absolute flex bottom-[80px] shadow-md left-[25%] rounded-lg overflow-hidden w-[711px] z-[9999] h-[467px] "
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-full h-full relative">
              <AiVideoPopover />
            </div>
          </div>
        </div>
      )}
      <div
        className="w-full py-[7px] bg-white flex justify-center items-center absolute bottom-0 z-[100]"
        onClick={(e) => e.stopPropagation()}
      >
        {toolsList.map((tool, index) => {
          const selected = currentTab === index;

          return (
            <div
              key={tool.name}
              className={`px-2 py-3 cursor-pointer ${
                selected ? "bg-[#0049C61A] rounded-lg" : ""
              } `}
              onClick={() => {
                //   if (isDisabled) {
                //     return;
                //   }
                onTabClick(index);
              }}
            >
              <div
                className={`group relative flex items-center gap-1 ${
                  selected ? "text-[#6043DB] font-bold" : "text-[#11142D]"
                }`}
              >
                <img
                  src={selected ? tool.selectedIcon : tool.icon}
                  alt={tool.name}
                  className="w-5 h-5"
                />
                <span className="text-xs font-bold leading-[14px]">
                  {tool.name}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default AiDubbingTools;
